export default __webpack_public_path__ + "static/media/site_logo_light.e8735626.png";